// Init.ts
// -------
// Self calling function which procedurally checks for compatibility and sets browser up before initializing the app
// Return value: Boolean; Allows the child code to conditionally start app based on result
import Constants from './shared/constants';
import * as Cookies from 'js-cookie';
import { environment } from '../environments/environment';

export class Init {
  // Browser feature support flags
  browserSupported = true;

  // Browser support DOM handles
  unsupportedBrowser = document.getElementById('unsupportedBrowser');

  // Authentication DOM handles
  overlay = document.getElementById('overlay');

  constructor() {
    // Check for browser support by required features
    this.browserSupported = this.isBrowserSupported();
    this.getContrast();
  }

  isBrowserSupported(): boolean {
    const browserSupportsCORS = 'withCredentials' in new XMLHttpRequest();
    let browserSupportsLocalStorage = false;

    if (typeof localStorage === 'object') {
      try {
        localStorage.setItem('localStorage', '1');
        localStorage.removeItem('localStorage');
        browserSupportsLocalStorage = true;
      } catch (e) {}
    }

    if (!browserSupportsCORS || !browserSupportsLocalStorage) {
      return false;
    } else {
      return true;
    }
  }

  getParam(param: string): string {
    // Take any param out of the page query params
    const search: any = location.search.replace(/&amp;/g, '&').replace('?', '').split('&');
    let value: string = null;

    search.map((item: any, index: number) => {
      const values: string = item.split('=');
      if (values[0] === param) {
        value = values[1];
      }
    });

    return value;
  }

  getContrast(): void {
    const contrast = this.getParam('contrast');
    if (contrast === 'true') {
      Cookies.set(Constants.CONTRAST, true, {domain: environment.DOMAIN});
    } else if (contrast && contrast !== 'true') {
      Cookies.remove(Constants.CONTRAST, {domain: environment.DOMAIN});
    }
  }

  showUnsupportedBrowser(): void {
    this.unsupportedBrowser.style.display = 'block';
  }

  destroyUnsupportedBrowser(): void {
    this.unsupportedBrowser.parentNode.removeChild(this.unsupportedBrowser);
  }

  showOverlay(): void {
    this.overlay.classList.remove('overlay-hide');
  }

  hideOverlay(): void {
    this.overlay.classList.add('overlay-hide');
  }

  destroyOverlay(): void {
    this.overlay.parentNode.removeChild(this.overlay);
  }
}
